import { useMemo } from 'react';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { getRfpClientStatus, getRfpClientIsEnd, } from '@/utils/modules/rfp/client/rfpClientStatus';
/**
 * 提案募集中の案件 取得したデータを view に渡す形に整える
 * @param args
 * @returns
 */
export const useClientMyPageProjectRfp = (args) => {
    var _a;
    const { profile, rfpsPaging } = args;
    const clientMySolution = useTypeSelector((state) => state.clientMySolution);
    const totalRowCount = (clientMySolution === null || clientMySolution === void 0 ? void 0 : clientMySolution.rfpsTotal) || 1;
    const rfpData = (_a = clientMySolution === null || clientMySolution === void 0 ? void 0 : clientMySolution.rfps) === null || _a === void 0 ? void 0 : _a[rfpsPaging];
    /**
     * テーブルの行データ
     */
    const rows = useMemo(() => {
        if (!rfpData) {
            return undefined;
        }
        return rfpData.map((d) => {
            const { id, is_order: isOrder, name, representative: representativeData, selectable_offer_count: selectableOfferCount, status, unanswered_negotiate_message_count: unansweredNegotiateMessageCount, unanswered_online_question_count: unansweredOnlineQuestionCount, unread_negotiate_message_count: unreadNegotiateMessageCount, view_request_approval_count: viewRequestApprovalCount, view_request_proposal_count: viewRequestProposalCount, view_request_unapproved_count: viewRequestUnapprovedCount, } = d;
            const representative = representativeData
                ? {
                    firstName: representativeData.first_name,
                    isProfile: representativeData.id === profile.id,
                    lastName: representativeData.last_name,
                }
                : undefined;
            return {
                id,
                interviewSelectableOfferCount: selectableOfferCount,
                isEnd: getRfpClientIsEnd({ isOrder, status }),
                messageUnanswerCount: unansweredNegotiateMessageCount,
                messageUnreadCount: unreadNegotiateMessageCount,
                proposalCount: viewRequestProposalCount,
                questionUnansweredCount: unansweredOnlineQuestionCount,
                representative,
                status: getRfpClientStatus({ isOrder, status }),
                title: name,
                viewRequestUnapprovedCount,
                viewRequestViewsCount: viewRequestApprovalCount,
            };
        });
    }, [profile.id, rfpData]);
    /**
     * テーブル全体のデータ
     */
    const rfpTableData = useMemo(() => ({
        currentPage: rfpsPaging,
        rows,
        totalRowCount,
    }), [rfpsPaging, totalRowCount, rows]);
    return {
        rfpTableData,
    };
};
